import React, { useCallback, useState } from "react";
import { BiCloudUpload } from "react-icons/bi";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import Text from "../../typography/Text";

const DragAndDrop = ({ onChange = () => {}, accept = "image/*", imageExist = null}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null); // Store preview URL
  const onDrop = useCallback(
    (acceptedFiles) => {
      const imageFiles = acceptedFiles.filter((file) =>
        file.type.startsWith("image/")
      );

      if (imageFiles.length === 0) {
        toast("Please select image files only.");
        return;
      }

      const selectedFile = imageFiles[0];
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile)); // Create preview URL
      onChange(imageFiles);
    },
    [onChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: accept,
  });

  return (
    <div className="h-full">
      <div
        {...getRootProps()}
        className="flex flex-col gap-6 rounded-lg mx-auto p-5"
        style={{
          background: isDragActive ? "whitesmoke" : "transparent",
          transform: isDragActive ? "scale(0.95)" : "scale(1)",
          transition: "0.4s",
          cursor: "pointer",
          height: '100%'
        }}
      >
        <input style={{ display: "none" }} {...getInputProps()} accept={accept} />

        {preview || imageExist ? (
          <div className="border border-black border-gray-300 rounded-md flex p-4 self-center text-center w-full h-full image-container">
            <img src={preview || imageExist} alt="Preview" className="w-full h-auto rounded-md object-contain" />
            {/* <Text className="!text-sm !font-semibold">
              Click or drag another image to replace
            </Text> */}
          </div>
        ) : (
          <div className="border border-black border-gray-300 rounded-md flex flex-col gap-4 items-center p-14 self-center text-center">
            <BiCloudUpload size={50} />
            <Text className="!text-sm !font-semibold !inline">
              <Text className="!text-sm !font-semibold !text-primary !inline">
                Click to upload{" "}
              </Text>
              or drag and drop SVG, PNG, JPG, or GIF
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default DragAndDrop;
